import { defineMessages, type MessageValue, type NoMessageValues } from 'react-intl';

export const giftCardCheckoutAmountMessages = defineMessages<{
  readonly sectionTitle: NoMessageValues;
  readonly customOptionTitle: NoMessageValues;
  readonly customOptionFieldLabel: { readonly max: MessageValue; readonly min: MessageValue };
}>({
  sectionTitle: {
    defaultMessage: 'Amount',
    description: 'Gift Card Checkout Form | Amount | Section title',
  },
  customOptionTitle: {
    defaultMessage: 'Custom',
    description: 'Gift Card Checkout Form | Amount | Custom option title',
  },
  customOptionFieldLabel: {
    defaultMessage: 'Enter amount between {min} and {max}',
    description: 'Gift Card Checkout Form | Amount | Custom option field label',
  },
});
